import React from "react";
import { IStyledSVGIconProps, StyledSVGIcon } from "./icon.style";

export const UserAccessRequestIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      version="1.1"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
      width="20.892" 
      height="20.892" 
      viewBox="0 0 20.892 20.892"
      x="0px"
      y="0px"
      style={{ enableBackground: "new 0 0 42.3 48.4" }}
      xmlSpace="preserve"
      {...props}
    >
      <path id="Serviceaccount" d="M0,10.446A10.446,10.446,0,1,0,10.446,0,10.424,10.424,0,0,0,0,10.446Zm10.446-8.84a8.812,8.812,0,0,1,8.84,8.84,8.944,8.944,0,0,1-3.212,6.832v-1.2a3.749,3.749,0,0,0-2.814-3.457,3.764,3.764,0,0,0,1.2-2.814V8.759A3.922,3.922,0,0,0,10.6,4.823h-.163a3.861,3.861,0,0,0-4.017,3.7v1.2a3.784,3.784,0,0,0,1.2,2.814c-1.606.642-2.814,1.769-2.814,3.457v1.2a8.9,8.9,0,0,1-1.2-12.455,9.15,9.15,0,0,1,6.832-3.135Z" fill="#007bc3"/>
    </StyledSVGIcon>
  );
};
